import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PieChart } from "@mui/x-charts/PieChart";
import { BarChart } from "@mui/x-charts/BarChart";
import { getAllDashboardAnalytics } from "services/usersServices";
import { compose } from "redux";
import { withRouter } from "react-router";
import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";

const { success, error, fetching } = NavigationActions;

const Dashboard = props => {
  const { token, success, error, fetching, user } = props;

  const [analyticsData, setAnalyticsData] = useState({
    counts: [
      {
        data: [
          { id: 0, value: 0, label: "Total" },
          { id: 1, value: 0, label: "Active" },
          { id: 2, value: 0, label: "In-Active" }
        ]
      }
    ],
    subscriptionCounts: [{ data: [0, 0, 0] }]
  });

  const [isLoading, setIsLoading] = useState(true);

  const getAllDashboardAnalyticsData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllDashboardAnalytics(token);
      if (response?.success) {
        const data = {
          counts: [
            {
              data: [
                {
                  id: 0,
                  value:
                    response.data.activeUsers + response.data.inactiveUsers,
                  label: "Total",
                  color: "#37B4FF"
                },
                {
                  id: 1,
                  value: response.data.activeUsers,
                  label: "Active",
                  color: "#02D6D2"
                },
                {
                  id: 2,
                  value: response.data.inactiveUsers,
                  label: "In-Active",
                  color: "#8E44AD"
                }
              ]
            }
          ],
          subscriptionCounts: [
            {
              data: [response.data?.paidUsers, response.data?.cancelledUsers]
            }
          ]
        };

        setAnalyticsData(data);
      } else {
        error(response.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllDashboardAnalyticsData();
  }, []);

  console.log(analyticsData);
  const barChartColors = ["#4caf50", "#f44336"];
  return (
    <div className="container-fluid">
      <div className="row title-sec align-items-center">
        <div className="col-sm headline">Dashboard</div>
        <div className="col-sm-auto ml-auto"></div>
      </div>
      <div className="div-container">
        <div className="row ma-0">
          <div className="col-auto card rounded py-4 mb-3">
            <h3>Merchant Stats</h3>
            {/* Conditionally render PieChart */}
            {!isLoading && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <div>
                  <PieChart
                    series={[
                      {
                        data: analyticsData.counts[0].data.map(item => ({
                          id: item.id,
                          value: item.value,
                          label: item.label,
                          color: item.color
                        })),
                        highlightScope: {
                          faded: "global",
                          highlighted: "item"
                        },
                        faded: { innerRadius: 30, additionalRadius: -10 }
                      }
                    ]}
                    width={400}
                    height={200}
                    slotProps={{ legend: { hidden: true } }}
                    tooltip={{ trigger: "item" }}
                    desc="User Stats"
                    title="User Stats"
                    loading={false}
                  />
                </div>
                <div style={{ marginTop: 20 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left"
                          }}
                        >
                          Color
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left"
                          }}
                        >
                          Label
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left"
                          }}
                        >
                          Call Counts
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {analyticsData.counts[0].data.map((item, index) => (
                        <tr key={index}>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            <div
                              style={{
                                width: 20,
                                height: 20,
                                backgroundColor: item.color
                              }}
                            ></div>
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {item.label}
                          </td>
                          <td
                            style={{ border: "1px solid #ddd", padding: "8px" }}
                          >
                            {item.value}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
          <div className="col-12 card rounded py-4">
            <h3>Subscription Stats</h3>

            {/* Show BarChart */}
            {!isLoading && (
              <>
                <BarChart
                  xAxis={[
                    {
                      scaleType: "band",
                      data: ["Paid", "Cancelled"]
                    }
                  ]}
                  series={analyticsData.subscriptionCounts}
                  height={300}
                  colors={barChartColors}
                  tooltip={{ trigger: "item" }} // Show data on hover
                  showLabels
                />

                {/* Show Data in Table */}
                <div style={{ marginTop: 20 }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left"
                          }}
                        >
                          Color
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left"
                          }}
                        >
                          Label
                        </th>
                        <th
                          style={{
                            border: "1px solid #ddd",
                            padding: "8px",
                            textAlign: "left"
                          }}
                        >
                          Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Table Rows */}
                      {analyticsData.subscriptionCounts[0].data.map(
                        (value, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px"
                              }}
                            >
                              {/* Color Box */}
                              <div
                                style={{
                                  width: 20,
                                  height: 20,
                                  backgroundColor: barChartColors[index]
                                }}
                              ></div>
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px"
                              }}
                            >
                              {["Paid", "Cancelled"][index]}
                            </td>
                            <td
                              style={{
                                border: "1px solid #ddd",
                                padding: "8px"
                              }}
                            >
                              {value}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>

        {isLoading && <Loader />}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(Dashboard);
